// modalsMap.ts
import CreateActivityModal from '../components/modals/operations/planning/CreateActivityModal';
import RemainingPeopleModal from '../components/modals/operations/planning/RemainingPeopleModal';
import RemainingMaterialModal from '../components/modals/operations/planning/RemainingMaterialModal';
import CalendarModal from '../components/modals/CalendarModal';
import { ModalProps } from '../components/modals/ModalBody';
import CreateActivityNeedsModal from '../components/modals/operations/needs/CreateActivityNeedsModal';
import ImportLastNeedsModal from '../components/modals/operations/needs/ImportLastNeedsModal';
import DuplicateActivityModal from '../components/modals/operations/planning/DuplicateActivityModal';
import CreateDailyMachineModal from '../components/modals/operations/planning/ManageDailyMachineModal';
import CreateDailyToolModal from '../components/modals/operations/planning/ManageDailyToolModal';
import CreateDailyRentalModal from '../components/modals/operations/planning/ManageDailyRentalModal';
import ManageDailyTruckPlannedModal from '../components/modals/operations/planning/ManageDailyTruckPlannedModal';
import ManageDailyTransferModal from '../components/modals/operations/planning/ManageDailyTransferModal';

export const modalsMap = {
    activity: CreateActivityModal,
    people: RemainingPeopleModal,
    material: RemainingMaterialModal,
    calendar: CalendarModal,
    createActivityNeeds: CreateActivityNeedsModal,
    importLastNeeds: ImportLastNeedsModal,
    duplicateActivity: DuplicateActivityModal,
    manageDailyMachine: CreateDailyMachineModal,
    manageDailyTool: CreateDailyToolModal,
    manageDailyRental: CreateDailyRentalModal,
    manageDailyTrucksPlanned: ManageDailyTruckPlannedModal,
    manageDailyTransfersPlanned: ManageDailyTransferModal,
};

export type ModalName = keyof typeof modalsMap;

export type ModalPropsMap = {
    activity: ModalProps & React.ComponentProps<typeof CreateActivityModal>;
    createActivityNeeds: ModalProps & React.ComponentProps<typeof CreateActivityNeedsModal>;
    people: ModalProps & React.ComponentProps<typeof RemainingPeopleModal>;
    material: ModalProps & React.ComponentProps<typeof RemainingMaterialModal>;
    calendar: ModalProps & React.ComponentProps<typeof CalendarModal>;
    importLastNeeds: ModalProps & React.ComponentProps<typeof ImportLastNeedsModal>;
    duplicateActivity: ModalProps & React.ComponentProps<typeof DuplicateActivityModal>;
    manageDailyMachine: ModalProps & React.ComponentProps<typeof CreateDailyMachineModal>;
    manageDailyTool: ModalProps & React.ComponentProps<typeof CreateDailyToolModal>;
    manageDailyRental: ModalProps & React.ComponentProps<typeof CreateDailyRentalModal>;
    manageDailyTrucksPlanned: ModalProps & React.ComponentProps<typeof ManageDailyTruckPlannedModal>;
    manageDailyTransfersPlanned: ModalProps & React.ComponentProps<typeof ManageDailyTransferModal>;
};
